/**
 * @file コンポーネント：ノートドロワー スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { zIndex } from "~/src/styles/constants";

// スタイル
export const StyledDrawer = styled.div`
    display: none;
    flex-direction: column;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: ${zIndex.fullvideoDrawerNote};
    width: 100%;
    height: calc(100% - 172px);
    min-height: 225px;
    max-height: calc(100% - 121px);
    padding-top: 50px;
    overflow: hidden;
    border-radius: 8px 8px 0 0;
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.3);
    background-color: #ffffff;
    touch-action: none;

    &.is-open {
        display: flex;
    }

    .is-android &,
    .is-iphone & {
        height: calc(100% - 96px - 56.25vw);
    }
`;

export const StyledDrawerClose = styled.button`
    position: absolute;
    top: 6px;
    left: 8px;
    z-index: 2;
    width: 23px;
    border: none;
    background-color: transparent;
    color: #424242;
    font-size: 13px;
    line-height: 21px;
    text-align: center;
`;

export const StyledDrawerHeader = styled.div`
    position: absolute;
    top: 5px;
    right: 0;
    left: 0;
    z-index: 1;
    width: 72px;
    height: 3px;
    margin: 0 auto;
    padding: 3px 20px 20px;
    box-sizing: content-box;
    cursor: grab;

    &::before {
        display: block;
        width: 100%;
        height: 100%;
        background-color: #d9d9d9;
        content: "";
    }

    &.is-drag {
        cursor: grabbing;
    }
`;

export const StyledDrawerNote = styled.div`
    flex-grow: 1;
    overflow-y: hidden;
`;

export const StyledDrawerTitle = styled.h2`
    flex-shrink: 0;
    margin-bottom: 13px;
    padding: 0 20px;
    overflow: hidden;
    color: #000000;
    font-weight: normal;
    font-size: 14px;
    line-height: 15.7px;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
